import * as React from "react";
import { useState, useEffect } from 'react';
import {
    List,
    Show,
    Edit,
    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,

    TabbedShowLayout,
    Tab,
    BooleanInput,
    Create,
    PasswordInput,
    NumberInput,
    ImageField,
    useRecordContext,
    useRefresh,
    useUpdate,
    FileField,
    Button,
    WrapperField,
    Toolbar,
    SaveButton,
    InfiniteList,
    TopToolbar,
    ReferenceManyField,
    SingleFieldList,
    ChipField,
    FunctionField,
    EditButton,
    TabbedForm,
    AutocompleteArrayInput,
    useGetIdentity,
    SelectInput,
    usePermissions,
} from 'react-admin';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ReplyIcon from '@mui/icons-material/Reply';
import SendIcon from '@mui/icons-material/Send';
import { apiUrl, authenticatedApi, baseUrl, setAccessToken } from "../dataProvider";
import { locationString, objectToSelectChoices, stateAbbrToName, supportRequestStatuses } from "../helpers/strings";
import { ReferenceManyToManyInput } from "@react-admin/ra-relationships";
import { CommunityOptionRenderer, GenericOptionRenderer } from "../Components/OptionRenderer";
import { format, formatISO, parseISO } from "date-fns";
import { useGetList } from 'react-admin';
import { Box, List as MUIList, ListItem, ListItemText } from '@mui/material';
import { TextField as MUITextField } from '@mui/material';

{/* <QuickFilter source="views_lte" label="Low views" defaultValue={150} />, */}
const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const getAttributionFromUser = (user) => {
    if(!user) {
        return '';
    }

    // check communities first
    if(user.communities && user.communities.length) {
        const community = user.communities[0];
        return locationString(community);
        // return `${community.name} | ${locationString(community)}`;
    }

    if (user.coordinating_programs && user.coordinating_programs.length) {
        const coordinatingProgram = user.coordinating_programs[0];
        return `${coordinatingProgram.name}`;
    }

    return '';
};

const SupportRequestAttributionField = (props) => {
    const record = useRecordContext();

    let attribution = getAttributionFromUser(record?.user);

    /*
    if(record && record.user) {
        // check communities first
        if(record.user.communities && record.user.communities.length) {
            const community = record.user.communities[0];
            attribution = `${community.name} | ${community.city}, ${community.state}`;
        } else if(record.user.coordinating_programs && record.user.coordinating_programs.length) {
            const coordinatingProgram = record.user.coordinating_programs[0];
            attribution = `${coordinatingProgram.name}`;
        }
        // record.user
    }

    // if(!record) {
    // }
    */

    return <FunctionField label="Community / Program" render={<span>{attribution}</span>} />
};


let lpVideos = [
    ['Completing the Assessment', 'https://www.youtube.com/watch?v=if5vsUHOwAw&list=PLN0bDNWGJJuNKnCILMi5xSkBu1wQFMvVl&index=2&pp=iAQB'],
    ['Support Tickets', 'https://www.youtube.com/watch?v=zIBCMXM8zvA&list=PLN0bDNWGJJuNKnCILMi5xSkBu1wQFMvVl&index=3&pp=iAQB'],
    ['Account Settings', 'https://www.youtube.com/watch?v=s-RBa0Zzy9c&list=PLN0bDNWGJJuNKnCILMi5xSkBu1wQFMvVl&index=1&pp=iAQB'],
];

let cpVideos = [
    ['Dashboard Overview', 'https://www.youtube.com/watch?v=DJS3TDW8dD4&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=3&pp=iAQB'],
    ['Communities', 'https://www.youtube.com/watch?v=a-ZIxebsfRY&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=2&pp=iAQB'],
    ['Forms', 'https://www.youtube.com/watch?v=PZxQYrCy2ww&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=5&pp=iAQB'],
    ['Form Entries', 'https://www.youtube.com/watch?v=gl5si0PUj-g&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=4&pp=iAQB'],
    ['Users', 'https://www.youtube.com/watch?v=fgEbqLksXaU&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=8&pp=iAQB'],
    ['Support Requests', 'https://www.youtube.com/watch?v=cGE5Tk3RUAk&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=7&pp=iAQB'],
    ['Reports', 'https://www.youtube.com/watch?v=Bi6NKOBF4vg&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=6&pp=iAQB'],
    ['Audit Log', 'https://www.youtube.com/watch?v=zqRFHpWKtMo&list=PLN0bDNWGJJuNcutZCSFLR154rjgnxgWqk&index=1&pp=iAQB'],
];

let msaVideos = [
    ['Announcements', 'https://www.youtube.com/watch?v=X4uBs_vHCcY&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=1&pp=iAQB'],
    ['Communities', 'https://www.youtube.com/watch?v=7l6TzzwSoiI&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=11&pp=iAQB'],
    ['Coordinating Programs', 'https://www.youtube.com/watch?v=mv40nybvF6U&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=3&pp=iAQB'],
    ['Forms', 'https://www.youtube.com/watch?v=cfuado1RUl4&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=6&pp=iAQB'],
    ['CP Form Overrides', 'https://www.youtube.com/watch?v=q_PfZcNAWSY&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=4&pp=iAQB'],
    ['Form Entries', 'https://www.youtube.com/watch?v=akKaciaVdOU&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=5&pp=iAQB'],
    ['Users', 'https://www.youtube.com/watch?v=s1bKfPx_AZs&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=10&pp=iAQB'],
    ['Support Requests', 'https://www.youtube.com/watch?v=IjqOefglkRc&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=9&pp=iAQB'],
    ['Reports', 'https://www.youtube.com/watch?v=g-KVLdykwkg&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=7&pp=iAQB'],
    ['Audit Log', 'https://www.youtube.com/watch?v=iCtSrGuBgjI&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=2&pp=iAQB'],
    ['Settings', 'https://www.youtube.com/watch?v=FobQVJptymc&list=PLN0bDNWGJJuNqb4YbpBcECHqWZT3LQ_X1&index=8&pp=iAQB'],
];


const SupportRequestListActions = ({ showAll, setShowAll }) => (
    <TopToolbar>
        <Button
            label={showAll ? "MSA: Show Elevated Tickets Only" : "MSA: Show All Tickets"}
            onClick={() => setShowAll(!showAll)}
            sx={{
                fontSize: '1.25rem',    // larger text
                padding: '12px 24px',   // bigger padding for larger clickable area
                minWidth: '200px',      // wider button
                textTransform: 'none',  // keep normal case if needed, remove uppercase default
            }}
        />
    </TopToolbar>
);


const StaffAssignment = () => {
    const refresh = useRefresh();
    const { permissions } = usePermissions();
    const record = useRecordContext();
    const [update, { loading }] = useUpdate();

    const { data: staffList = [], isLoading } = useGetList(
        'users',
        {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'name', order: 'ASC' },
            filter: { is_staff: true }
        }
    );

    const [searchTerm, setSearchTerm] = React.useState('');
    const [assignedStaff, setAssignedStaff] = React.useState([]);
    const [confirmAddId, setConfirmAddId] = React.useState(null);
    const [confirmRemoveId, setConfirmRemoveId] = React.useState(null);

    React.useEffect(() => {
        setAssignedStaff(record?.staff || []);
    }, [record]);

    React.useEffect(() => {
        // Reset confirmation after 5s timeout
        if (confirmAddId) {
            const timer = setTimeout(() => setConfirmAddId(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [confirmAddId]);

    React.useEffect(() => {
        if (confirmRemoveId) {
            const timer = setTimeout(() => setConfirmRemoveId(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [confirmRemoveId]);

    if (!permissions?.msa) {
        return null;
    }

    if (isLoading) {
        return <p>Loading staff...</p>;
    }

    // Filter available staff: those not assigned AND matching the search term
    const availableStaff = staffList
        .filter(staff => !assignedStaff.find(a => a.id === staff.id))
        .filter(staff => (staff.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                 (staff.email || '').toLowerCase().includes(searchTerm.toLowerCase()));

    // Filter assigned staff with search term
    const filteredAssignedStaff = assignedStaff.filter(staff =>
        (staff.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (staff.email || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleAdd = (staff) => {
        if (confirmAddId === staff.id) {
            update('support-requests', { id: record.id, data: { staff_add: staff.id } }, {
                onSuccess: () => {
                    setAssignedStaff([...assignedStaff, staff]);
                    setConfirmAddId(null);
                    refresh();
                },
                onError: () => {
                    setConfirmAddId(null);
                    alert('Failed to assign staff');
                }
            });
        } else {
            setConfirmAddId(staff.id);
            setConfirmRemoveId(null); // reset any remove confirm
        }
    };

    const handleRemove = (staff) => {
        if (confirmRemoveId === staff.id) {
            update('support-requests', { id: record.id, data: { staff_remove: staff.id } }, {
                onSuccess: () => {
                    setAssignedStaff(assignedStaff.filter(a => a.id !== staff.id));
                    setConfirmRemoveId(null);
                    refresh();
                },
                onError: () => {
                    setConfirmRemoveId(null);
                    alert('Failed to unassign staff');
                }
            });
        } else {
            setConfirmRemoveId(staff.id);
            setConfirmAddId(null); // reset any add confirm
        }
    };

    return (
        <Paper
            elevation={3}
            sx={{
                padding: 2,
                marginBottom: '2rem',
                maxWidth: 800,
                width: '100%',
            }}
        >
            <Typography variant="h6" gutterBottom>
                Assign Staff Members
            </Typography>

            <MUITextField
                label="Search Staff by Name or Email"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                fullWidth
                sx={{ marginBottom: 2 }}
            />

            <Box sx={{ display: 'flex', gap: 4 }}>
                {/* Unassigned Staff List */}
                <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1">Unassigned Staff Members</Typography>
                    <MUIList sx={{ maxHeight: 200, overflowY: 'auto' }}>
                        {availableStaff.length === 0 && (
                            <Typography variant="body2">No staff found</Typography>
                        )}
                        {availableStaff.map(staff => {
                            const isConfirming = confirmAddId === staff.id;
                            return (
                                <ListItem
                                    key={staff.id}
                                    button
                                    dense
                                    disabled={loading}
                                    onClick={() => handleAdd(staff)}
                                    sx={{
                                        bgcolor: isConfirming ? 'error.main' : 'inherit',
                                        color: isConfirming ? 'white' : 'inherit',
                                        py: 0.5,
                                        '&:hover': {
                                            bgcolor: isConfirming ? 'error.dark' : 'action.hover',
                                            color: isConfirming ? 'white' : 'inherit',
                                            cursor: 'pointer',
                                        },
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            isConfirming
                                                ? `Click again to assign ${staff.name}`
                                                : (
                                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                                                        <Typography variant="body2" sx={{ flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {staff.name}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                                            {staff.email}
                                                        </Typography>
                                                    </Box>
                                                )
                                        }
                                    />
                                </ListItem>
                            );
                        })}
                    </MUIList>
                </Box>

                {/* Assigned Staff List */}
                <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1">Assigned Staff Members</Typography>
                    <MUIList sx={{ maxHeight: 200, overflowY: 'auto' }}>
                        {filteredAssignedStaff.length === 0 && (
                            <Typography variant="body2">No staff assigned</Typography>
                        )}
                        {filteredAssignedStaff.map(staff => {
                            const isConfirming = confirmRemoveId === staff.id;
                            return (
                                <ListItem
                                    key={staff.id}
                                    button
                                    dense
                                    disabled={loading}
                                    onClick={() => handleRemove(staff)}
                                    sx={{
                                        bgcolor: isConfirming ? 'error.main' : 'inherit',
                                        color: isConfirming ? 'white' : 'inherit',
                                        py: 0.5,
                                        '&:hover': {
                                            bgcolor: isConfirming ? 'error.dark' : 'action.hover',
                                            color: isConfirming ? 'white' : 'inherit',
                                            cursor: 'pointer',
                                        },
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            isConfirming
                                                ? `Click again to unassign ${staff.name}`
                                                : (
                                                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                                                        <Typography variant="body2" sx={{ flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {staff.name}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                                            {staff.email}
                                                        </Typography>
                                                    </Box>
                                                )
                                        }
                                    />
                                </ListItem>
                            );
                        })}
                    </MUIList>
                </Box>
            </Box>
        </Paper>
    );

};


const HelpList = props => {
    const { isLoading, permissions } = usePermissions();

    console.log(permissions);

    if(isLoading) {
        return <div>Waiting...</div>
    }

    return (
    <TableContainer component={Paper} sx={{marginTop: 8}}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Local Program</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                <TableRow>
                    <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={`${baseUrl}/documents/MSA-Accreditation-LP-Manual-v1.pdf`} target="_blank">User Manual</a></TableCell>
                </TableRow>
                {lpVideos.map((vid, index) => (
                    <TableRow key={index}>
                        <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={vid[1]} target="_blank">Video: {vid[0]}</a></TableCell>
                    </TableRow>
                ))}
                </TableBody>

                {(permissions?.cp || permissions?.msa || permissions?.staff) && <>
                    <TableHead>
                    <TableRow>
                        <TableCell>Coordinating Program</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    <TableRow>
                        <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={`${baseUrl}/documents/MSA-Accreditation-CP-Manual-v1.pdf`} target="_blank">User Manual</a></TableCell>
                    </TableRow>
                    {cpVideos.map((vid, index) => (
                        <TableRow key={index}>
                            <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={vid[1]} target="_blank">Video: {vid[0]}</a></TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </>}

                {(permissions?.msa || permissions?.staff) && <>
                    <TableHead>
                    <TableRow>
                        <TableCell>Main Street America</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    <TableRow>
                        <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={`${baseUrl}/documents/MSA-Accreditation-MSA-Manual-v1.pdf`} target="_blank">User Manual</a></TableCell>
                    </TableRow>
                    {msaVideos.map((vid, index) => (
                        <TableRow key={index}>
                            <TableCell sx={{paddingLeft: 8}}><a className="text-blue-500 hover:text-blue-800" href={vid[1]} target="_blank">Video: {vid[0]}</a></TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </>}
                <TableHead>
                <TableRow>
                    <TableCell>DNS Allowlist</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                <TableRow>
                    <TableCell sx={{paddingLeft: 8}}>
                        <p>If mainstreetreporting.org is inaccessible due to your internal DNS server restrictions or DNS policies, please have your IT department add the following records:</p>
                        <code>
                        A record<br/>
                        mainstreetreporting.org<br/>
                        Points to<br/>
                        34.237.162.129<br/>
                        <br/>
                        CNAME record<br/>
                        www.mainstreetreporting.org<br/>
                        Points to<br/>
                        mainstreetreporting.org<br/>
                        <br/>
                        A record<br/>
                        api.mainstreetreporting.org<br/>
                        Points to<br/>
                        34.237.162.129<br/>
                        </code>

                        <p><b>Additional Requirements for Coordinating Programs and MSA:</b> <br/>(Not Necessary for Local Programs)</p>
                        <code>
                        A record<br/>
                        admin.mainstreetreporting.org<br/>
                        Points to<br/>
                        34.237.162.129<br/>
                        </code>
                    </TableCell>
                </TableRow>
                </TableBody>
        </Table>
    </TableContainer>
)   ;
}

const SupportRequestList = props => {
  const { permissions } = usePermissions();
  const { identity, isLoading } = useGetIdentity();
  const [showAll, setShowAll] = useState(false); // false => show elevated only for MSA

  if (isLoading) return null;

  // Prioritize MSA view when the user has msa permission.
  let filter = {};
  if (permissions?.msa) {
    // MSA wins if user has msa (even with staff)
    filter = showAll ? {} : { elevated_to_msa: 1 };
    } else if (permissions?.staff) {
    // Staff only
    filter = { staff: { user_id: identity.id } };
    }

  console.log('SupportRequestList effective filter', { permissions, identity, showAll, filter });

  return (
    <InfiniteList
        {...props}
        filter={filter}
        exporter={false}
        actions={
        permissions.msa
            ? <SupportRequestListActions showAll={showAll} setShowAll={setShowAll} />
            : null
        }
    >
        <Datagrid rowClick="edit">
        <FunctionField
            sortable={false}
            label="Message"
            render={record => {
            const lastMessage = record.messages?.[record.messages.length - 1];
            if (!lastMessage) return <b>{record.subject}</b>;

            const lastMessageAuthor = lastMessage.user?.name?.trim() || 'Unknown user';

            const attribution = getAttributionFromUser(record?.user);
            const authorDisplay = attribution
                ? `${attribution} (${lastMessageAuthor})`
                : lastMessageAuthor;

            const lastMessageText = `${lastMessage.message}<br/>–${authorDisplay}, ${format(parseISO(lastMessage.created_at), 'P')}`;

            return (
                <>
                <b>{record.subject}</b>
                <br />
                <p dangerouslySetInnerHTML={{ __html: lastMessageText }}></p>
                </>
            );
            }}
        />

        <FunctionField
            sortable={false}
            label="Author"
            render={record => record.user?.name?.trim() || 'Unknown user'}
        />

        <FunctionField
            sortable={false}
            label="Status"
            render={record => record.status === 'open' ? 'Open' : 'Closed'}
        />

        <EditButton icon={<ReplyIcon />} label="Respond" />
        </Datagrid>
    </InfiniteList>
    );
};

const SupportRequestShow = props => (
    <Show {...props} title={'View User'}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SimpleShowLayout>
                            <TextField source="name" />
                            <EmailField source="email" />
                            <BooleanField label="Is MSA Admin?" source="is_msa" looseValue />
                            <DateField source="updated_at" />
                        </SimpleShowLayout>
                    </Grid>
                    {/*
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h6" gutterBottom>Impersonate User</Typography>
                        <Typography gutterBottom>This will log you in as the user. To become yourself again, log out and back in.</Typography>
                        <ImpersonateUserButton />
                    </Grid>
                    */}
                </Grid>

            </Tab>
            <Tab label="Communities">
                <ArrayField source="communities" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/communities/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField sortable={false} source="name" />

                        <TextField sortable={false} source="city" />
                        <FunctionField sortable={false} label="State" source="state" render={record => stateAbbrToName(record.state)} />

                        {/* <DateField source="created_at" label={'Created'} /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>

            <Tab label="Coordinating Programs">
                <ArrayField source="coordinating_programs" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/coordinating-programs/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField sortable={false} source="name" />

                        <FunctionField sortable={false} label="State" source="state" render={record => stateAbbrToName(record.state)} />
                        {/* <TextField source="state" /> */}

                        {/* <DateField source="created_at" label={'Created'} /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
)

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const IsMsaCheckbox = props => {
    const { data: identity, isLoading: identityLoading } = useGetIdentity();
    // const record = useRecordContext();

    // Only let MSA users to set MSA status
    if(!identity?.is_msa) {
        return null;
    }

    return (<BooleanInput {...props} />);
};

const SupportRequestReplies = (props) => {
    const record = useRecordContext();
    console.log(record);

    if(!record?.messages?.length) {
        return null;
    }

    /*
    return (
        <ArrayField source="messages" record={record}>
            <Datagrid bulkActionButtons={false}>
                <TextField label={false} source="message"></TextField>
            </Datagrid>
        </ArrayField>
    );
    */

    return (<>
        {record.messages.map((message, index) => {

            let messageAuthor = message.user?.name?.trim() || 'Unknown user';
            let attribution = getAttributionFromUser(message?.user);
            if(attribution) {
                messageAuthor = `${attribution} (${messageAuthor})`;
            }

            {/* const latestMessage = request.messages[request.messages.length-1]; */}

                {/* <div className={`text-md tracking-tight px-6 py-3 ${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`} key={index}> */}
            return (
                <div key={index} style={{
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                    background: index % 2 === 0 ? '#f0f0f0' : 'white',
                }}>
                    <p style={{ fontSize: '85%', fontWeight: '600', marginBottom: '0' }}><em>{messageAuthor} wrote on {format(parseISO(message.created_at), 'MM/dd/yy \'at\' hh:mm aaaa')}</em></p>
                    <p style={{ marginTop: 0, maxWidth: '50vw' }} dangerouslySetInnerHTML={{__html: message.message}}></p>
                </div>
            );
        })}
        <div style={{width: '100%', height: '3px', backgroundColor: '#777', marginTop: '0.5rem'}} />
    </>);

}

const SendToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label="Send" icon={<SendIcon/>} />
    </Toolbar>
);


const buttonStyles = {
    marginTop: '1rem',
    marginBottom: '2rem',
    padding: '12px 24px', // adjust padding for extra space
    textAlign: 'center',
};

const ElevateButton = () => {
    const { permissions } = usePermissions();
    const record = useRecordContext();
    const refresh = useRefresh();
    const [update, { loading }] = useUpdate();

    const [confirmElevate, setConfirmElevate] = React.useState(false);
    const [confirmDeElevate, setConfirmDeElevate] = React.useState(false);

    React.useEffect(() => {
        setConfirmElevate(false);
        setConfirmDeElevate(false);
    }, [record]);

    React.useEffect(() => {
        if (confirmElevate || confirmDeElevate) {
            const timer = setTimeout(() => {
                setConfirmElevate(false);
                setConfirmDeElevate(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [confirmElevate, confirmDeElevate]);

    if (!record) return null;

    if (permissions?.msa) {
        if (!record.elevated_to_msa) {
            return (
                <Button
                    onClick={() => {
                        if (confirmElevate) {
                            update(
                                'support-requests',
                                { id: record.uuid, data: { elevated_to_msa: 1 } },
                                { onSuccess: refresh }
                            );
                        } else {
                            setConfirmElevate(true);
                        }
                    }}
                    disabled={loading}
                    variant="contained"
                    color={confirmElevate ? "error" : "primary"}
                    style={buttonStyles}
                >
                    <span>{confirmElevate ? "Click again to elevate" : "Elevate to MSA"}</span>
                </Button>
            );
        } else {
            return (
                <Button
                    onClick={() => {
                        if (confirmDeElevate) {
                            update(
                                'support-requests',
                                { id: record.uuid, data: { elevated_to_msa: 0 } },
                                { onSuccess: refresh }
                            );
                        } else {
                            setConfirmDeElevate(true);
                        }
                    }}
                    disabled={loading}
                    variant="contained"
                    color={confirmDeElevate ? "error" : "secondary"}
                    style={buttonStyles}
                >
                    <span>{confirmDeElevate ? "Click again to lower" : "Lower back to CP"}</span>
                </Button>
            );
        }
    }

    if (permissions?.cp || permissions?.staff) {
        if (!record.elevated_to_msa) {
            return (
                <Button
                    onClick={() => {
                        if (confirmElevate) {
                            update(
                                'support-requests',
                                { id: record.uuid, data: { elevated_to_msa: 1 } },
                                { onSuccess: refresh }
                            );
                        } else {
                            setConfirmElevate(true);
                        }
                    }}
                    disabled={loading}
                    variant="contained"
                    color={confirmElevate ? "error" : "primary"}
                    style={buttonStyles}
                >
                    <span>{confirmElevate ? "Click again to elevate" : "Elevate to MSA"}</span>
                </Button>
            );
        } else {
            return (
                <span
                    style={{
                        fontWeight: 'bold',
                        color: '#1976d2',
                        display: 'block',
                        textAlign: 'center',
                        marginTop: '1rem',
                        marginBottom: '2rem',
                    }}
                >
                    Elevated to MSA
                </span>
            );
        }
    }

    return null;
};



const SupportRequestEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic" transform={data => ({
        ...data,
        confirm_password: data.password,
    })}>

        <SimpleForm toolbar={<SendToolbar/>}>

            <ElevateButton />

            <StaffAssignment />

            <SupportRequestReplies/>

            <div style={{height: '3px', backgroundColor: '#eee'}} />

            <TextInput source="message" label="Response" isRequired multiline fullWidth minRows={3} />

            <SelectInput source="status" isRequired choices={objectToSelectChoices(supportRequestStatuses)}/>
        </SimpleForm>
    </Edit>
);

const SupportRequestCreate = props => (
    <Create {...props} redirect="list" >
        <Alert severity="info">Note: This support ticket will be assigned to Main Street America.</Alert>
        <SimpleForm toolbar={<SendToolbar/>}>
            <TextInput source="subject" isRequired sx={{minWidth: '50%'}} />
            <TextInput source="message" isRequired fullWidth multiline minRows={3} />
        </SimpleForm>
    </Create>
);

export {HelpList, SupportRequestList, SupportRequestShow, SupportRequestEdit, SupportRequestCreate};
